module.exports = __webpack_public_path__ + "img/buddy_mouth-02.4c492d29.svg";